export const scrollToSection = (id: string) => {
  const section = document.getElementById(id);
  if (section) {
    const yOffset = -80; // adjust for sticky navbar
    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};